import {
  MelcoModelsUserTrialListItem,
  UserAccountApi,
  useAPIQuery,
} from "melco-shared-logic";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useUserLicensesTrials = (userId: string, productCode: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
  } = useTable<MelcoModelsUserTrialListItem>({});
  const query = useAPIQuery(
    UserAccountApi,
    ["UserLicensesTrials"],
    async (api) => {
      //const api = new UserAccountApi(baseApiConfig({ token, impersonationForId: userId }));
      //     console.log({ filters, currentPage, pageSize })
      let response;
      //if (filters?.searchText && !isEmpty(filters.searchText)) {

      response = await api.accountGetSubscriptionsTrials({
        productCode: productCode,
      });

      setTotal(response?.total ? response?.total : 0);
      //}

      console.log(response);
      return response?.list ? response?.list : [];
      // return response
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
      apiConfigOptions: {
        impersonationForId: userId ?? "",
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
